if (process.env.VUE_APP_BRAND === 'BK') {
  module.exports = {
    /**  BOLAGSKOMPASSEN-EDITION */
    colors: {
      Primary: '#00476b',
      PrimaryLight: '#2d7aa3',
      Secondary: '#009bea',
      Tertiary: '#eac300',
      Light: '#f2f2f2',
      Dark: '#003651',
      White: '#ffffff',
      LightGrey: '#d3d3d3',
      MidGrey: '#808080', // Tillagd
      DarkGrey: '#808080', // Denna färg skall nog bytas ut senare mot en mörkare
      Black: '#000000',
      Green: '#a4e408',
      Red: '#e70407',
      Positive: '#a4e408', // Skall ersätta Green
      Negative: '#e70407', // Skall ersätta Red
      MenuBg: '#00476b',
      MenuText: '#ffffff',
    },
    /** FORTNOX-EDITION
         colors: {
            Primary: "#276743", // Grön
            Secondary: "#fcc00d", // Gul
            Tertiary: "#f2610f", // Orange
            Light: "#f2f2f2",
            Dark: "#013823",  // Mörkgrön
            White: "#ffffff",
            LightGrey: "#d3d3d3",
            MidGrey: "#808080", 
            DarkGrey: "#808080", 
            Black: "#000000",
            Green: "#28a745", // Fortnox-grön
            Red: "#dc3545", //Röd
            Positive: "#28a745", // Fortnox-grön
            Negative: "#dc3545", // Röd
            MenuBg: "#00476b",
            MenuText: "#ffffff",
        }, */
    /** BDO-EDITION
         colors: {
            Primary: "#505050", // Grå
            Secondary: "#02a5e2", // Ljusblå
            Tertiary: "#df8639", // Orange
            Light: "#f2f2f2",
            Dark: "#323232",  // Mörkgrå
            White: "#ffffff",
            LightGrey: "#d3d3d3",
            MidGrey: "#808080", 
            DarkGrey: "#808080", 
            Black: "#000000",
            Green: "#28a745", // Fortnox-grön
            Red: "#ed1a3b", //Röd
            Positive: "#28a745", // Fortnox-grön
            Negative: "#ed1a3b", // Röd
            MenuBg: "#00476b",
            MenuText: "#ffffff",
        }, */
    /** Fintegrity
         colors: {
            Primary: "#904687",
            Secondary: "#36859a",
            Tertiary: "#e41081",
            Light: "#f2f2f2",
            Dark: "#333",
            White: "#ffffff",
            LightGrey: "#d3d3d3",
            MidGrey: "#808080", // Tillagd
            DarkGrey: "#808080", // Denna färg skall nog bytas ut senare mot en mörkare
            Black: "#000000",
            Green: "#a4e408",
            Red: "#e70407",
            Positive: "#a4e408", // Skall ersätta Green
            Negative: "#e70407", // Skall ersätta Red
            MenuBg: "#00476b",
            MenuText: "#ffffff",
        }, */
    brand: 'BK',
    showLogin: false,
    showWelcome: false,
    enableSharing: process.env.VUE_APP_HOST !== 'BK',
    initialCompany: '',
    logo: '',
    cards: ['valuation'],
    enableCardTic: false,
    templates:
      process.env.VUE_APP_HOST === 'BK'
        ? ['company', 'competitors', 'cashflow', 'flexible']
        : [
            'company',
            'competitors',
            'cashflow',
            'flexible',
            'webreport_cashflow',
            'valuation',
          ],
  };
}

if (process.env.VUE_APP_BRAND === 'GT') {
  module.exports = {
    colors: {
      Primary: '#4f2d7f',
      PrimaryLight: '#a06dff',
      Secondary: '#00a4b3',
      Tertiary: '#ffc23d',
      Light: '#f2f0ee',
      Dark: '#2b144d',
      White: '#ffffff',
      LightGrey: '#e0dcd7',
      MidGrey: '#ccc4bd',
      DarkGrey: '#808080',
      Black: '#000000',
      Green: '#9bd732',
      Red: '#ce2c2c',
      Positive: '#9bd732', // Skall ersätta Green
      Negative: '#ce2c2c', // Skall ersätta Red
      MenuBg: '#4f2d7f',
      MenuText: '#ffffff',
      //MenuBg:    '#ffffff',
      //MenuText:  '#3a1967',
    },
    brand: 'GT',
    showLogin: false,
    showWelcome: true,
    enableSharing: true,
    /** ST mode (.env.st): GT brand + VUE_APP_HOST=ST — TIC overview enabled. */
    enableCardTic: process.env.VUE_APP_HOST === 'ST',
    initialCompany: '556356-9382',
    logo: '/static/gt/image/GT_logo-Outline_WHITE.svg',
    cards: [''],
    templates: [
      // "company",
      'competitors',
      // "closingmeeting",
      'preClosingMeeting',
      'futuremeeting',
      'yearendmeeting',
      'cashflow',
      'flexible',
      'industryAnalysis',
      'competitorAnalysis',
      'deck-salesmeeting',
      'deck-yearendmeeting',
      'deck-startupmeeting',
      'deck-esgintroduction',
      'deck-esgkpi',
      'deck-company',
    ],
  };
}
